import React from "react";
import "./sectionTitleStyle.scss";

const SectionSubTitle = ({ title, className = "" }) => {
  return (
    <div className={`section-subtitle ${className}`}>
      <h2>{title}</h2>
    </div>
  );
};

export default SectionSubTitle;
